import { useState } from 'react'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { useAuthStore } from '../stores/auth.js'
import { api } from '../services/api.js'
import { usePageTitle } from '../hooks/usePageTitle.js'

export default function LoginPage() {
  usePageTitle('Sign in')
  const [form, setForm] = useState({ email: '', password: '' })
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const { login } = useAuthStore()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const inviteToken = searchParams.get('invite')
  // ?next= is the post-login landing page. Used to bounce users back to
  // /billing?plan=plus (etc.) after signing in from a pricing CTA.
  const next = searchParams.get('next')
  const plan = searchParams.get('plan')

  // Carry ?next + ?plan over to the register link so the flow survives
  // the "no account yet" switch.
  const registerQs = new URLSearchParams()
  if (next) registerQs.set('next', next)
  if (plan) registerQs.set('plan', plan)
  const registerHref = `/register${registerQs.toString() ? '?' + registerQs.toString() : ''}`

  async function handleSubmit(e) {
    e.preventDefault()
    setLoading(true); setError(null)
    try {
      const { token, user } = await api.post('/auth/login', form)
      login(token, user)
      if (inviteToken) {
        navigate(`/invite/${inviteToken}`)
      } else if (next && next.startsWith('/')) {
        // Only allow relative redirects — protect against open-redirect.
        navigate(next)
      } else {
        navigate('/')
      }
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <span className="auth-logo">Genealogic</span>
        <p className="auth-tagline">Bring your ancestors back to life</p>
        <form onSubmit={handleSubmit}>
          <label>
            Email
            <input type="email" value={form.email} placeholder="you@example.com"
              onChange={e => setForm({ ...form, email: e.target.value })} required />
          </label>
          <label>
            Password
            <input type="password" value={form.password} placeholder="••••••••"
              onChange={e => setForm({ ...form, password: e.target.value })} required />
          </label>
          <p className="auth-forgot"><Link to="/forgot-password">Forgot password?</Link></p>
          {error && <p className="error">{error}</p>}
          <button type="submit" className="btn btn-gold" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        <p className="auth-switch">
          No account yet? <Link to={registerHref}>Create one free</Link>
        </p>
      </div>
      <a href="https://genealogic.ai" className="auth-back">← Back to genealogic.ai</a>
    </div>
  )
}
